import Vue from "vue";

Vue.component("NavbarItem", () => import("./NavbarItem.vue"));
Vue.component("DropMenu", () => import("./DropMenu.vue"));
Vue.component("DropSubmenu", () => import("./DropSubmenu.vue"));
Vue.component("DropdownItem", () => import("./DropdownItem.vue"));
Vue.component("MenuMobileItem", () => import("./MenuMobileItem.vue"));
